import * as omitBy from 'lodash/omitBy'
import * as pick from 'lodash/pick'
import { ShareableInfo, ShareMethod } from 'interfaces/share'
import { encodeUrlParams } from 'helpers/utilsHelpers'
import { SHARE_URLS, SOCIAL_REWARD_AMOUNT } from 'constants/media'
import { formatUSCurrency } from 'helpers/formatHelpers'

export function generateReferralShareable (method: ShareMethod, inviteLink: string): ShareableInfo {
  switch (method) {
    case 'facebook':
      return {
        method,
        url: inviteLink,
      }

    case 'twitter':
      return {
        method,
        text: `Get $5 for joining @StatusMoneyUSA then earn unlimited cash rewards for improving your finances. Join for free:`,
        url: inviteLink,
      }

    case 'email':
      return {
        method,
        subject: `Get $5 for joining Status Money`,
        body:
          `Hi!

Use this link to join Status Money and you’ll get a ${ formatUSCurrency(SOCIAL_REWARD_AMOUNT) } reward:
${ inviteLink }

Status Money analyzes your finances to find ways for you to improve – then gives you cash rewards for taking action. And guess what – it’s free!`,
      }

    case 'native':
      return {
        method,
        title: `Get $5 for joining Status Money`,
        content: `Get $5 for joining Status Money then earn unlimited cash rewards for improving your finances. Join for free: ${ inviteLink }.`,
      }
  }
}

export function generateShareUrl (info: ShareableInfo): string | undefined {
  let shareParams

  switch (info.method) {
    case 'facebook':
      shareParams = {
        kid_directed_site: '0',
        sdk: 'joey',
        display: 'popup',
        ref: 'plugin',
        src: 'share_button',
        u: info.url,
      }
      break

    case 'twitter':
      shareParams = pick(info, ['text', 'url'])
      break

    case 'email':
      shareParams = pick(info, ['subject', 'body'])
      break

    case 'native':
    default:
      return undefined
  }

  if (!shareParams) {
    return undefined
  }

  const processedParams = encodeUrlParams(
    omitBy(
      shareParams,
      (value) => !value
    )
  )

  return `${ SHARE_URLS[info.method] }?${ processedParams }`
}


